module.exports = __webpack_public_path__ + "img/Medical_Program_icon01.990dc69b.png";